import { useI18n } from 'next-localization';

import { cn } from '@/lib/utils';
import { NeuIcon } from '@hcahealthcaredpx/neutron-react';

import styles from './badges.module.css';

export const Badges = ({
  acceptsNewPatients,
  telehealthProvider,
  className,
}: {
  acceptsNewPatients: boolean;
  telehealthProvider: boolean;
  className?: string;
}): JSX.Element => {
  const { t } = useI18n();

  return (
    <div className={cn('d-flex align-items-center flex-wrap', className)}>
      {acceptsNewPatients && (
        <span className={cn('overflow-lg-hidden', styles.badge)}>
          <NeuIcon name="groups" size="2x" className={styles.icon} />
          <span className={styles.truncate}>
            {t('OAS.Profile.Details.NewPatientOnlineBooking')}
          </span>
        </span>
      )}
      {telehealthProvider ? (
        <span className={cn('overflow-lg-hidden', styles.badge)}>
          <NeuIcon name="videocam" size="2x" className={styles.icon} />
          {t('OAS.Profile.Details.TelemedicineAvailable')}
        </span>
      ) : null}
    </div>
  );
};
